<script lang="ts">
	import { browser } from '$app/environment';
	import { goto } from '$app/navigation';
	import GenericError from '$lib/components/GenericError.svelte';

	if (browser) {
		goto('/app/enrich');
	}
</script>

<GenericError />
